import { useMutation, useQueryClient, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateProductsQueries } from '../../utils/query-invalidation';

type DeleteCreditTypeVariables = {
  creditTypeId: string;
};

export function useDeleteCreditType(options?: UseMutationOptions<void, unknown, DeleteCreditTypeVariables>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ creditTypeId }: DeleteCreditTypeVariables) => {
      const api = getPrivateApi();
      return await api.deleteCreditType({ creditTypeId });
    },
    onSuccess: async () => {
      await invalidateProductsQueries(queryClient);
    },
    ...options,
  });
}
